import * as React from "react";
// helper
import { ISvgIcons } from "./helper";

export const SearchIcon: React.FC<ISvgIcons> = ({ className = "", ...rest }) => (
  <svg
    viewBox="0 0 16 16"
    className={`${className}`}
    stroke="currentColor"
    stroke-width="1.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    {...rest}
  >
    <path d="M7.66659 14.0007C11.1644 14.0007 13.9999 11.1651 13.9999 7.66732C13.9999 4.16951 11.1644 1.33398 7.66659 1.33398C4.16878 1.33398 1.33325 4.16951 1.33325 7.66732C1.33325 11.1651 4.16878 14.0007 7.66659 14.0007Z" />
    <path d="M14.6666 14.6673L13.3333 13.334" />
  </svg>
);
